import React, { useEffect } from 'react'
import { isMobileOnly } from 'react-device-detect'

import {
  arrayHasElements,
  Content,
  Loader,
  OrderItemConfirm,
  Text
} from '../../components'

import { useBasket } from '../../providers'

import { useStyle } from './order-confirm.styles'

export const OrderConfirmPage = () => {
  const { draftedOrdersBulk, onClearDraftedOrdersBulk } = useBasket()
  const classes = useStyle()

  const h1Preset = isMobileOnly ? 'h1Mobile' : 'h1'

  useEffect(() => {
    return () => {
      if (onClearDraftedOrdersBulk) {
        onClearDraftedOrdersBulk()
      }
    }
  }, [])

  return (
    <Content
      className={classes.container}
      justifyContent="flex-start"
      padding="0px 16px 16px"
    >
      <Text
        className={classes.title}
        text="Confirm Payment"
        tx="order.confirm.confirm.payment"
        preset={h1Preset}
        color="black"
      />
      <Text
        className={classes.titleOwerview}
        text="Please carefully check the order(s) information below and choose way to pay."
        tx="order.confirm.payment.text"
        preset="h5"
        color="inactive"
      />
      <Text
        className={classes.titleOwerview}
        text="Important information: All Sales are Final."
        tx="order.confirm.payment.description"
        preset="h5"
        color="inactive"
      />
      {arrayHasElements(draftedOrdersBulk) ? (
        <>
          {draftedOrdersBulk.map((order) => {
            return (
              <OrderItemConfirm key={`orderConfirm_${order.id}`} {...order} />
            )
          })}
        </>
      ) : (
        <Loader />
      )}
    </Content>
  )
}
